const actionTypes = {
    GET_EVENTS_BY_RECON_SUCCESS: 'GET_EVENTS_BY_RECON_SUCCESS',
};

export default actionTypes;